import React from "react";
import { Fragment } from "react";

export default function PaymentHistoryHeader() {
  return (
    <Fragment>
        <h2>Payment History</h2>
    </Fragment>
  );
}
